import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PromoBanner from "@/components/PromoBanner";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
            <PromoBanner />
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <Toaster position="bottom-right" richColors closeButton />
        </div>
    );
}
